import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import './ConceptoVideo.scss';
import { useTranslation, Trans } from 'react-i18next';

const ConceptoVideo = (props) => {
  const { t } = useTranslation();

  const handleVideo = () => {
    props.setVideo(true);
    props.setUrlVideo("U1pR-yp3ajY");
  };

  return (
    <div id="concepto" className='contenedor_video'>
      <div className='contenedor_video__left'>
        <AnimationOnScroll
          duration={2}
          animateOnce={true}
          animateIn='animate__fadeIn'>
          <div className='contenedor_video__left_subtitulo'>
            <h2>{t('conceptoVideo.title')}</h2>
          </div>
        </AnimationOnScroll>
        <div className='contenedor_video__left_texto'>
          <p>
            <Trans
              i18nKey="conceptoVideo.description"
              components={{ bold: <strong /> }}
            />
          </p>
        </div>
        <div className='contenedor_video__left_button'>
          <a href='/#masterplan'>{t('conceptoVideo.availability')}</a>
        </div>
      </div>
      <div className='contenedor_video__right'>
        <img
          className='play'
          src="/assets/Logos/boton-de-play.png"
          alt={t('conceptoVideo.playButtonAlt')}
          onClick={() => handleVideo()}
        />
        <div className='contenedor_video__right_video'>
          <video src="/assets/Video/loop_velasur.mp4" autoPlay muted loop></video>
        </div>
      </div>
    </div>
  );
};

export default ConceptoVideo;
